export default {
	type: 'object',
	properties: {
		state: { type: 'string' },
	},
	additionalProperties: false,
}
